import { get } from "core-web/libs/GrebbCommerceAPI/util/authClient";

export default async (applicationId) => {
    const response = await get("/frontend/user", { application_id: applicationId });

    return await response;
};
